import React from 'react';
import { CheckCircle, Info, X } from 'lucide-react';

interface MVPLaunchBannerProps {
  onDismiss?: () => void;
}

export const MVPLaunchBanner: React.FC<MVPLaunchBannerProps> = ({ onDismiss }) => {
  const [isVisible, setIsVisible] = React.useState(true);

  const handleDismiss = () => {
    setIsVisible(false);
    onDismiss?.();
    localStorage.setItem('zippyhealth_mvp_banner_dismissed', 'true');
  };

  // Check if banner was previously dismissed
  React.useEffect(() => {
    const dismissed = localStorage.getItem('zippyhealth_mvp_banner_dismissed');
    if (dismissed === 'true') {
      setIsVisible(false);
    }
  }, []);

  if (!isVisible) return null;

  return (
    <div className="bg-gradient-to-r from-green-50 to-blue-50 dark:from-green-900/20 dark:to-blue-900/20 border border-green-200 dark:border-green-800 rounded-lg p-4 mb-6">
      <div className="flex items-start justify-between">
        <div className="flex items-start space-x-3">
          <div className="flex-shrink-0">
            <CheckCircle className="h-6 w-6 text-green-600 dark:text-green-400" />
          </div>
          <div className="flex-1">
            <h3 className="text-sm font-semibold text-green-800 dark:text-green-200 mb-1">
              🚀 ZippyHealth MVP Launch
            </h3>
            <p className="text-sm text-green-700 dark:text-green-300 mb-2">
              Welcome to our MVP! We've simplified the app to focus on core features that work perfectly:
            </p>
            <div className="grid grid-cols-2 gap-2 text-xs text-green-600 dark:text-green-400">
              <div className="flex items-center space-x-1">
                <CheckCircle className="h-3 w-3" />
                <span>Health Conditions</span>
              </div>
              <div className="flex items-center space-x-1">
                <CheckCircle className="h-3 w-3" />
                <span>Symptom Tracking</span>
              </div>
              <div className="flex items-center space-x-1">
                <CheckCircle className="h-3 w-3" />
                <span>Food Tracker</span>
              </div>
              <div className="flex items-center space-x-1">
                <CheckCircle className="h-3 w-3" />
                <span>Medication Manager</span>
              </div>
            </div>
          </div>
        </div>
        <button
          onClick={handleDismiss}
          className="flex-shrink-0 text-green-400 hover:text-green-600 dark:text-green-500 dark:hover:text-green-300"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}; 